import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanActivateFn, CanLoad, CanMatch, CanMatchFn, mapToCanMatch, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';

import { Observable, of, switchMap } from 'rxjs';

import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';



export const authguardGuard: CanActivateFn = (route, state) => {
  return true;
};
@Injectable({
  providedIn: 'root'
})
export class RoutePermissionGuards implements CanActivate {
  menu_items = []
  site_url = '';
  /**
   * Constructor
   */
  constructor(

    private _router: Router,

  ) {


  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot,): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectUrl = state.url;
    this.site_url = state.url
    console.log(redirectUrl, "redirectUrlllllllllll");

    return this.validateRoutePrmsnCheck(redirectUrl);

  }


  getMenuItems = () => {
    if (this.menu_items && this.menu_items.length == 0) {
      let mn = localStorage.getItem('menu_items');
      if (mn) {
        this.menu_items = JSON.parse(mn);
        return this.menu_items
      }

    }
    else {
      return this.menu_items
    }

  }




  private validateRoutePrmsnCheck(redirectURL: string): Observable<boolean> {
    // if (environment.production) {
    //   let url_mtch = false;
    //   let gt_mn_itms = this.getMenuItems();
    //   console.log("MENU", gt_mn_itms);
    //   let common_routes = ['/access-denied', '/sign-out', '/sign-in/home', '/sign-in', '/404-not-found']
    //   for (let index = 0; index < common_routes.length; index++) {
    //     const cmn_element = common_routes[index];
    //     if (cmn_element && cmn_element.match(redirectURL)) {
    //       url_mtch = true;
    //       break;
    //     }
    //   }
    //   if (!url_mtch && gt_mn_itms && gt_mn_itms.length) {
    //     for (let index = 0; index < gt_mn_itms.length; index++) {
    //       const element = gt_mn_itms[index];
    //       if (element && element['children'] && element['children'].length) {
    //         for (let ch_index = 0; ch_index < element['children'].length; ch_index++) {
    //           const ch_element = element['children'][ch_index];
    //           if (ch_element && ch_element['link'] && ch_element['link'].match(redirectURL)) {
    //             url_mtch = true;
    //             break;
    //           }
    //           if (ch_element && ch_element['children'] && ch_element['children'].length) {
    //             for (let ch_index2 = 0; ch_index2 < ch_element['children'].length; ch_index2++) {
    //               const ch_element2 = ch_element['children'][ch_index2];
    //               if (ch_element2 && ch_element2['link'] && ch_element2['link'].match(redirectURL)) {
    //                 url_mtch = true;
    //                 break;
    //               }
    //             }
    //           }
    //           if (url_mtch) {
    //             break;
    //           }
    //         }
    //         if (url_mtch) {
    //           break;
    //         }
    //       }
    //       else {
    //         if (element && element['link'] && element['link'].match(redirectURL)) {
    //           url_mtch = true;
    //           break;
    //         }
    //       }
    //     }
    //   }

    //   console.log("MATCHED =------------------------------------ ", url_mtch)
    //   if (url_mtch) {
    //     return of(true);
    //   }
    //   else {
    //     localStorage.setItem('access_dnd_url', this.site_url)
    //     let rte = '/access-denied';
    //     this._router.navigate([rte]);
    //     return of(false);
    //   }
    // }
    // else {
      return of(true);
    // }



  }

}




